<template>
    <div>
        <b-toast
        id="toast-check-modal-finish"
        variant="none"
        no-close-button
        toaster="b-toaster-top-center"
        >
        <img
          src="@/assets/img/ico-check.png"
          style="margin-right: 10px; margin-top: -2px"
        />
        {{ message }}
        </b-toast>
        <b-toast
        id="toast-equis-modal-finish"
        variant="none"
        no-close-button
        toaster="b-toaster-top-center"
        >
        <img
          src="@/assets/img/ico-equis.png"
          style="margin-right: 10px; margin-top: -2px"
        />
        {{ message }}
        </b-toast>
        <b-form-radio-group class="text-center mb-5" id="radio-button-evaluations" 
             v-model="selectedAssignmentsEvaluations" :options="optionsAssignmentsEvaluations"
            @change="handleChangeTab()"
        ></b-form-radio-group>
        <div class="d-flex align-items-center justify-content-between" style="margin-bottom: 24px;" v-if="selectedAssignmentsEvaluations">
            <div v-if="flagHistory" class="filters">
                <h5>{{nameSubject}}</h5>  
            </div>
            <div v-else class="filters">
                <b-form-group>
                    <b-form-select v-model="generalCourse" :options="optionsCourse" @change="changeList" style="width: 312px;">
                    </b-form-select>
                </b-form-group>
            </div>
            <b-row class="resultNote" style="width: 367px;" v-if="typeSubject==1">
                <b-col class="justify-content-end">
                    <h6>Overall Score:  </h6>
                    <span>{{valuePercentage == '' ?  '-' : valuePercentage}}</span>
                </b-col>
                <b-col class="pr-0">
                    <b-button class="btn btn-primary" :disabled="!flagFinishSubject"  @click="finishCourses">
                        
                         <span v-if="!showSpinnerFinish" style="color:#FFFFFF;">Finish course</span>
                        <b-spinner style="width: 1rem !important; height: 1rem !important; color:#FFFFFF;" v-else label="Spinning">                            
                        </b-spinner>
                        
                       </b-button>
                       <b-modal 
                        id="modalFinishCourse" 
                        :hide-footer="true"
                        :hide-header="true"  
                        >
                        <h6 class="sub-title"><span>{{$t('assignments-evaluations.modal-fc.title')}}</span></h6>
                        <div class="d-block text-right">
                            <button class="btn btn-danger mr-3" style="display:initial" @click="$bvModal.hide('modalFinishCourse')">{{$t('assignments-evaluations.modal-fc.button')}}</button>                            
                        </div>
                        
                    </b-modal>
                </b-col>
            </b-row>
            <b-row class="resultNote" style="width: 456px;"  v-if="typeSubject==2">
                <b-col class="justify-content-end">
                    <h6>Overall Score:  </h6>
                      <span>{{valuePercentage == '' ?  '-' : valuePercentage}}</span>
                </b-col> 
            </b-row>
        </div>
        <!-- el otro filtro ------------------ -->
        <div class="d-flex align-items-center justify-content-between" style="margin-bottom: 24px;" v-else>
              <div v-if="flagHistory" class="filters">
                <h5>{{nameSubject}}</h5>  
            </div>
            <div v-else class="filters">
           
                 <b-form-group>
                    <b-form-select v-model="generalCourse" :options="optionsCourse" @change="changeList" style="width: 312px;">
                    </b-form-select>
                </b-form-group>
            </div>
          
        </div>
        <b-table hover :items="itemsAssignments" :fields="fielAssignments"   :busy="isBusy"   :show-empty="true"
                    id="table-request-teacher"  :tbody-transition-props="transProps"   style="white-space: pre-line;"
                    :empty-text="$t('reusables.empty-text')">

                      <template #table-busy>
                    <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong> {{$t('ClassRequest.Loading')}}...</strong>
                    </div>
                </template>
            <template #cell(files)="data">
                <div v-if="data.item.files > 0">
                    <span v-if="data.item.flagRowEdited">
                        <a  @click="goEvaluationsReview(data.item)" class="link noBorder">{{`${data.item.files} ${data.item.files == 1 ? "File" : "Files"}`}}</a>
                        <p>{{data.item.comments}}</p>
                    </span>
                    <p v-else style="color: #b7b8bd">{{`${data.item.files} ${data.item.files == 1 ? "File" : "Files"}`}}</p>

                  
                </div>
                <div v-else>
                    <b-button v-if="selectedAssignmentsEvaluations" @click="linkFileUpload(data.item)"  class="btn btn-primary">
                            <icon name="cloud-file" />
                             {{$t('evaluacion.buttons.subir-evaluacion')}}
                        </b-button>
                        <p v-else>-</p>
                </div>
            </template>
            <template #cell(calification)="data">
                <div>
                    <a :class="[ !data.item.flagCalification ? 'pending' : ''   ]" class="link noBorder ">{{data.item.calification}}</a>
                </div>
              
            </template>
            <template #cell(feedback)="data">
                <div v-if="data.item.id == 0">-</div>
                <div v-else>
                    <a v-if="data.item.feedback" @click="goEvaluationsReview(data.item)"   style="font-family: 'Gotham_Rounded_Book';" :class="[ !data.item.feedback ? 'pending' : ''  ]" class="link noBorder ">Read</a>
                     <a v-else style="font-family: 'Gotham_Rounded_Book';" :class="[ !data.item.feedback ? 'pending' : ''  ]" class="link noBorder ">Pending</a>
                    <!--<a class="link noBorder" v-if="data.item.feedback=='Read'">{{data.item.feedback}}</a>
                    <a class="link noBorder" style="color:#D4263A;font-family: 'Gotham_Rounded_Book';" v-else>{{data.item.feedback}}</a>-->
                </div>
            </template>
            <template  #cell(review)="data">
                <div v-if="data.item.id == 0">-</div>
                <div v-else  @click="goEvaluationsReview(data.item)" style="width: fit-content;margin: auto;">
                  
                    <img src="@/assets/icons/icon-revision.svg" class="svg">
                </div>
            </template>
        </b-table>
        <div class="overflow-auto content-pagination">
                <b-pagination
                v-model="currentPageEval"
                :total-rows="totalRowsEval"
                :per-page="perPageEval"
              
                aria-controls="table-request-teacher"
                ></b-pagination>
                {{currentPageEval}}-{{perPageEval}} / {{totalRowsEval}}  {{$t('ClassRequest.text.3')}}
        </div>
    </div>
</template>
<script>
import { baseInstanceAxios } from '@/assets/js/axiosBase.js';
import * as tools from '@/assets/js/tools.js';
export default {
    data(){
        return{
            typeSubject : 0,
            nameSubject : '',
            flagFinishSubject:false,
            valuePercentage: '',
            message: '',
            groupId : 0 ,
            groupPlanId : 0,
            flagTab : false,
            flagHistory : false,
            isBusy: false,
            showSpinnerFinish : false,
            currentPageEval: 1,
            perPageEval : 10,
            totalRowsEval:  0,
            personStudentId: 0 ,
            selectedAssignmentsEvaluations: false,
            generalCourse:null,
            optionsCourse:[],
            transProps: {
                name: 'flip-list'
            },
            optionsAssignmentsEvaluations: [
                {text:'Assignments',  value : false},
                {text: 'Evaluations', value : true}  
            ],
            assignments:null,
            fielAssignments:[
                {key:'module' , label: this.$t('assignments-evaluations.table-th.units')},
                {key:'files' , label: this.$t('assignments-evaluations.table-th.files')},
                {key:'date' , label: this.$t('assignments-evaluations.table-th.date')},
                {key:'calification' , label: this.$t('assignments-evaluations.table-th.calification')},
                {key:'feedback' , label: this.$t('assignments-evaluations.table-th.feedback')},
                {key:'review' , label: this.$t('assignments-evaluations.table-th.review')},

            ],
            itemsAssignments: [
            ],
            optionsAllCourse: []
        }
    },
    
    created(){

        this.flagHistory = this.$route.params.flagHistory
        this.nameSubject  =  this.$route.params.nameSubject
        this.personStudentId = this.$route.params.personStudentId
        this.selectedAssignmentsEvaluations = this.$route.params.flagTab
        this.groupId  =this.$route.params.groupId
    
        if(this.flagHistory){
            this.groupPlanId = this.$route.params.groupPlanId
            this.getListCoursesHistory();
    
        }else{
          
             this.getListComboTeacher();
           
        }
       

      /*  window.addEventListener('beforeunload', (event) => {
     
         this.$router.push({name : 'student/evaluaciones'})
      })*/
    },
    watch:{
        	currentPageEval: {
			handler: function(newVal, oldVal) {
                if(newVal != null){
                    if(this.flagHistory){
                        this.getListCoursesHistory();
                    }else{
                         this.getListPersonPage();
                    }
                   
                }
				
			}
		},
        selectedAssignmentsEvaluations: {
            handler: function(newVal, oldVal){
                this.optionsCourse = newVal ? this.optionsAllCourse.filter(x => x.valor != 3) : this.optionsAllCourse;
            }
        }
    },
    mounted(){
       
        this.$root.$on('updateTab', (value) => { 
            this.personStudentId = value.personStudentId
            this.selectedAssignmentsEvaluations   =value.flagTab
            this.groupId  =  value.groupId
            this.getListComboTeacher();
         
        })
        this.$nextTick(function () {
            tools.imgToSvg()
        })
    },
    /*computed:{
       
        typeSubject : {
            get() {
                return parseInt( this.generalCourse.split('-')[1])
            }
        }
    },*/
    methods:{
           getListCoursesHistory(){

            this.isBusy = true;
             let data = {
                id: this.$route.params.registerId,
                flagEvaluation :this.selectedAssignmentsEvaluations ,
                page : this.currentPageEval,
                size : this.perPageEval,
                timezone: this.$store.state.user.timeZoneName
            }
           
            this.items1 = []
            baseInstanceAxios
            .get(`${this.apiURL}/resources/PersonsAssignmentsEvaluations/GetPersonsAssignmentsEvaluationsBySubjectsHistory`,{
                params : data
            } )
            .then(response => {
              
                if(response.data.entity){
                    this.titleCourseHistory = response.data.entity.strSubjectName_EN;
                    this.valueState =  response.data.entity.stateSubject ?  response.data.entity.stateSubject.name : '';
                    this.nameLevel  = response.data.entity.level ?  response.data.entity.level.abbreviation : '',
                    this.valuePercentage = response.data.entity.entityPersonsAssignmentEvaluation ?  response.data.entity.entityPersonsAssignmentEvaluation.strScore : ''
                    this.totalRowsEval = response.data.entity.personsAssignmentsEvaluations.rows
                    this.generalCourse = response.data.entity.groupRegisterSubjectId+"-"+response.data.entity.typeSubject+"-"+response.data.entity.strSubjectName_EN
                    
                    this.typeSubject = response.data.entity.typeSubject
                    this.flagFinishSubject = response.data.entity.flagFinishSubject
                    this.itemsAssignments = response.data.entity.personsAssignmentsEvaluations.list.map(element =>({
                        id : element.id,
                        groupPersonId :element.groupPersonId,
                        personId: element.personId,
                        strModule : element.strModule_EN,
                        groupPlanId : element.groupPlanId,
                        module: element.module != null && element.module > 0 ? element.module : '-' ,
                        files:element.fileCount,
                        date:element.strSubmittedDateHour_EN ? element.strSubmittedDateHour_EN : '-',
                        flagCalification : element.score != null ? true : false,
                        calification: element.score != null ? element.strScore : 'Pending',
                        comments : element.studentComments,
                        feedback:element.teacherComments != "" && element.teacherComments != null ? true : false,
                        review:'-',
                        //flagRowEdited : parseInt(this.generalCourse.split('-')[1]) == 2 ? element.flagRowEdited : true
                        flagRowEdited : element.flagRowEdited
                    }))

                     
                 
                    this.$nextTick(function () {
                        tools.imgToSvg()
                    })

                    this.isBusy = false;
                }
            
         
            });
            
        },
        finishCourses(){

            this.showSpinnerFinish = true;
            let data = {
                groupRegisterSubjectId: this.generalCourse.split('-')[0],
                personsStudentId:this.personStudentId , 
                personsteacherId: this.$store.state.user.personTeacherId, 
                User: this.$store.state.user.email
            }
            let url = `${this.apiURL}/resources/PersonsAssignmentsEvaluations/SaveByFinishSubject`
            if(this.flagHistory){
                data.personStudentSubjectHistoryId = this.$route.params.registerId;
                data.groupPlanId = this.groupPlanId;
                url  = `${this.apiURL}/resources/PersonsAssignmentsEvaluations/SaveByFinishSubjectHistory`
            }
 

            baseInstanceAxios
            .get(url,{
                params : data
            } )
            .then(response => {
                 if(this.flagHistory){
                    this.message = this.$t('assignments-evaluations.completed-course');
                    this.$bvToast.show("toast-check-modal-finish");
                    this.$router.push({
                            name : 'teacher/class',                        
                        }).catch(err => {}); 
                 } else{
                    if(response.data.value == -1){
                        this.$bvModal.show('modalFinishCourse');
                    }else{
                        this.message = this.$t('assignments-evaluations.completed-course');
                        this.$bvToast.show("toast-check-modal-finish");
                        this.$router.push({
                            name : 'teacher/class',                        
                        }).catch(err => {}); 
                    }
                 }  

                this.showSpinnerFinish = false;
         
            }).catch((error) => {
                this.message = this.$t('assignments-evaluations.error-completing-courses');
                this.$bvToast.show("toast-equis-modal-finish");
                this.showSpinnerFinish =  false;  
            });  
        },
        getListPersonPage(){
            this.typeSubject = parseInt(this.generalCourse.split('-')[1]);
            this.isBusy = true;
            let data = {
                personStudentid:  this.personStudentId,
                groupRegisterSubjectId: parseInt(this.generalCourse.split('-')[0]),
                typeSubject: parseInt(this.generalCourse.split('-')[1]),
                flagEvaluation :this.selectedAssignmentsEvaluations  ,
                page : this.currentPageEval,
                size : this.perPageEval,
                timezone: this.$store.state.user.timeZoneName
            }
            this.items1 = []
            //`${this.apiURL}/resources/PersonsAssignmentsEvaluations/ListPersonsAssignmentsEvaluationsBySubjects`
            baseInstanceAxios
            .get(`${this.apiURL}/resources/PersonsAssignmentsEvaluations/GetPersonsAssignmentsEvaluationsBySubjects`,{
                params : data
            } )
            .then(response => {
                
                if(response.data){
                  
                    this.itemsAssignments = response.data.entity.personsAssignmentsEvaluations.list.map(element =>({
                        id : element.id,
                        groupPersonId :element.groupPersonId,
                        personId: element.personId,
                        strModule : element.strModule_EN,
                        groupPlanId : element.groupPlanId,
                        module: element.module != null && element.module > 0 ? element.module : 'N/A' ,
                        files:element.fileCount,
                        date:element.strSubmittedDateHour_EN ? element.strSubmittedDateHour_EN : '-',
                        flagCalification : element.score != null ? true : false,
                        calification: element.score != null ? element.strScore : 'Pending',
                        comments : element.studentComments,
                        feedback:element.teacherComments != "" && element.teacherComments != null ? true : false,
                        review:'-',
                        flagRowEdited : parseInt(this.generalCourse.split('-')[1]) == 2 ? element.flagRowEdited : true
                    }))
                    this.$nextTick(function () {
                        tools.imgToSvg()
                    })

                     this.isBusy = false;
                }
         
            });  
        },
        getListPerson(){
            this.typeSubject = parseInt(this.generalCourse.split('-')[1]);
            this.isBusy = true;
                let data = {
                personStudentid:  this.personStudentId,
                groupRegisterSubjectId: parseInt(this.generalCourse.split('-')[0]),
                typeSubject: parseInt(this.generalCourse.split('-')[1]),
                flagEvaluation :this.selectedAssignmentsEvaluations  ,
                page : this.currentPageEval,
                size : this.perPageEval,
                timezone: this.$store.state.user.timeZoneName
            }
            this.itemsAssignments = [] 
            baseInstanceAxios
            .get(`${this.apiURL}/resources/PersonsAssignmentsEvaluations/GetPersonsAssignmentsEvaluationsBySubjects`,{
                params : data
            } )
            .then(response => {
                
                if(response.data.entity){
                    this.valuePercentage = response.data.entity.entityPersonsAssignmentEvaluation ? 
                     response.data.entity.entityPersonsAssignmentEvaluation.strScore : ''
                
                    this.flagFinishSubject = response.data.entity.flagFinishSubject
                    this.totalRowsEval = response.data.entity.personsAssignmentsEvaluations.rows
                    this.itemsAssignments = response.data.entity.personsAssignmentsEvaluations.list.map(element =>({
                        id : element.id,
                        groupPersonId :element.groupPersonId,
                        personId: element.personId,
                        strModule : element.strModule_EN,
                        module: element.module != null && element.module > 0 ? element.module : '-',
                        files:element.fileCount,
                        groupPlanId : element.groupPlanId,
                        date:element.strSubmittedDateHour_EN ? element.strSubmittedDateHour_EN : '-',
                        flagCalification : element.score != null ? true : false,
                        calification: element.score != null ? element.strScore : 'Pending',
                        comments : element.studentComments,
                        feedback:element.teacherComments != "" && element.teacherComments != null ? true : false,
                        review:'-',
                        flagRowEdited : parseInt(this.generalCourse.split('-')[1]) == 2 && this.selectedAssignmentsEvaluations? element.flagRowEdited : true
                    }))

                     if(this.selectedAssignmentsEvaluations && response.data.entity.personsAssignmentsEvaluations.list.length < this.perPageEval && response.data.entity.personsAssignmentsEvaluations.list.length < this.perPageEval){
                        if(parseInt(this.generalCourse.split('-')[1]) == 2 || parseInt(this.generalCourse.split('-')[1]) == 3){
                              this.itemsAssignments.push({
                                id : 0,
                                personId: 0,
                                strModule : null,
                                module:  '-' ,
                                files:0,
                                date: '-',
                                calification: '-',
                                comments :'-',
                                feedback: false,
                                review:'-',
                                flagRowEdited : false                                
                            })
                        }                  
                      }
                    this.$nextTick(function () {
                        tools.imgToSvg()
                    })

                    this.isBusy = false;
                }
            
            });
        },

        
        changeList(){
            this.currentPageEval = 1,
            this.totalRowsEval = 0
            this.getListPerson();
        },
        getListComboTeacher(){
            let data = {
                PersonStudentId : this.personStudentId,
                FlagEvaluation : this.selectedAssignmentsEvaluations 
            }
       
            baseInstanceAxios
                .get(`${this.apiURL}/Resources/Subjects/ComboSubjectsByGroupPersonId`,{
                    params : data
                } )
                .then(response => {
                    if(response.data.list.length>0){
     
                        //console.log("ComboSubjectsByGroupPersonId: response.data.list[0].descripcion_EN")
                        this.generalCourse =  response.data.list[0].id+"-"+response.data.list[0].valor+"-"+ response.data.list[0].descripcion_EN
                        //this.typeSubject = parseInt( this.generalCourse.split('-')[1])
                        this.typeSubject = response.data.list[0].valor
                        
                        this.optionsAllCourse = response.data.list.map(element =>({
                                value: element.id+"-"+element.valor+"-"+element.descripcion_EN,
                                text: element.descripcion_EN,
                                valor: element.valor
                        }));
                        this.optionsCourse = this.optionsAllCourse;
                        this.getListPerson();
                    }
                });
        },
        handleChangeTab(){
         
            this.currentPageEval = 1;
            this.totalRowsEval = 0;
            if(this.flagHistory){
                this.getListCoursesHistory();
                
            }else{
                this.getListComboTeacher();
            }
            
        },
        backStep(){
             this.$router.push({name : 'teacher/class'})
        },
        goEvaluationsReview(item){
        
            let nameSubject = ''
            if(this.flagHistory){
                nameSubject  = this.titleCourseHistory;
            }else{
                nameSubject  = this.generalCourse.split('-')[2];
            }

            this.$router.push({name : 'teacher-student-evaluations-reports-evaluations-review' , params : 
            {
                id: 1 , 
                registerId: this.$route.params.registerId,
                nameSubject: nameSubject,
                groupId: this.groupId  , 
                flagHistory:  this.flagHistory,
                groupPlanId:this.groupPlanId,
                personStudentId: this.$route.params.personStudentId,
                gridId: item.id,
                groupRegisterSubjectId: parseInt(this.generalCourse.split('-')[0]),
                typeSubject: parseInt(this.generalCourse.split('-')[1]),
                flagEvaluation: this.selectedAssignmentsEvaluations , 
                groupPersonId: item.groupPersonId,
                module: {
                    id: item.module,
                    strModule: item.strModule
                }
            }})
        },

        linkFileUpload(item){
            const data = {
                id: item.id , 
                flagEdited: true, 
                course: this.generalCourse , 
                flagEvaluation:this.selectedAssignmentsEvaluations,
                groupPersonId: item.groupPersonId,
                personStudentId: this.personStudentId,
                groupId: this.groupId  ,
                module: {
                    id: item.module,
                    strModule:item.strModule
                }   
            }
            this.$router.push({name : 'evaluation-teacher-file-upload', params : data}).catch(err => {}); 
        },
    }
}
</script>